<template>
  <div id="DebtorReport">
    <loading v-if="loadingRender"></loading>
    <panel
      Title="گزارش برداشت از حساب"
      Des="از طریق این فرم می‌توانید لیست برداشت‌ها از حساب‌های خود را مشاهده نمایید"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <net-pa-card>
      <template slot="header">
        <h6 class="text-right">
          <i class="fas fa-hand-holding-usd"></i>
          گزارش برداشت از حساب
        </h6>
      </template>
      <template slot="content">
        <div class="debtor-report-filters" id="Date">
          <p class="debtor-report-hint">
            حساب مورد نظر را انتخاب کنید و سپس
            <strong>جستجو</strong>
            را بزنید.
          </p>
          <div class="debtor-report-filters__row">
            <div class="debtor-report-field debtor-report-field--account">
              <label class="debtor-report-label" for="cmbTaahodat"
                >انتخاب حساب</label
              >
              <select
                v-if="IsLoad"
                name="cmbTaahodat"
                id="cmbTaahodat"
                class="form-control Pointer"
                v-model="Resultcmb"
              >
                <option v-if="this.IsLoad == false" value="-2">
                  || در حال بارگذاری ، منتظر بمانید ... ||
                </option>
                <option selected value="-1">-- انتخاب حساب --</option>
                <option
                  v-for="item in this.ListModel"
                  :key="item.id"
                  :value="item.vCode"
                >
                  <span>{{ item.vcodeDesNo }} </span
                  ><span>{{ item.nameFamily }} </span>
                </option>
              </select>
            </div>
            <div class="debtor-report-field debtor-report-field--date">
              <label class="debtor-report-label">از تاریخ</label>
              <date-picker
                :auto-submit="true"
                :max="TarikhTa"
                color="#287db4"
                v-model="TarikhAz"
              ></date-picker>
              <input
                type="text"
                tabindex="-1"
                class="d-none InputText"
                style="direction: ltr"
              />
            </div>
            <div class="debtor-report-field debtor-report-field--date">
              <label class="debtor-report-label">تا تاریخ</label>
              <date-picker
                :auto-submit="true"
                :min="TarikhAz"
                color="#287db4"
                v-model="TarikhTa"
              ></date-picker>
              <input
                type="text"
                tabindex="-1"
                class="d-none InputText"
                style="direction: ltr"
              />
            </div>
            <div class="debtor-report-field debtor-report-field--action">
              <span
                class="debtor-report-label debtor-report-label--spacer"
                aria-hidden="true"
                >&nbsp;</span
              >
              <button
                type="button"
                class="btn btn-success debtor-report-search-btn"
                @click="
                  GetDebtorReport();
                  $ResetTimer();
                "
              >
                <i class="fa fa-search ml-1" aria-hidden="true"></i>
                جستجو
              </button>
            </div>
            <div
              v-if="rows.length > 0"
              class="debtor-report-field debtor-report-field--action"
            >
              <span
                class="debtor-report-label debtor-report-label--spacer"
                aria-hidden="true"
                >&nbsp;</span
              >
              <button
                type="button"
                class="sv-btn sv-btn--ghost debtor-report-cancel-all-btn"
                @click="
                  DeleteAllEnteghal(rows);
                  $ResetTimer();
                "
                title="لغو همه درخواست‌های تایید نشده"
              >
                لغو همه
              </button>
            </div>
          </div>
        </div>
    <vue-bootstrap4-table
      :rows="rows"
      :columns="columns"
      :config="config"
      :classes="classes"
    >
      <template slot="sort-asc-icon">
        <i class="fa fa-sort-up"></i>
      </template>
      <template slot="sort-desc-icon">
        <i class="fa fa-sort-down"></i>
      </template>
      <template slot="no-sort-icon">
        <i class="fa fa-sort"></i>
      </template>
      <template slot="empty-results">
        <p class="text-right">اطلاعاتی یافت نشد</p>
      </template>
      <template slot="shomareSanad" slot-scope="props">
        <div class="debtor-report-status">
          <span
            class="debtor-report-status__badge"
            :class="'debtor-report-status--' + statusOf(props.row).key"
            :title="statusOf(props.row).title"
          >
            <i
              :class="statusIcon(statusOf(props.row).key)"
              aria-hidden="true"
            ></i>
            {{ statusOf(props.row).label }}
          </span>
          <button
            v-if="statusOf(props.row).canCancel"
            type="button"
            class="debtor-report-cancel-btn"
            title="لغو درخواست تایید نشده"
            @click="DeleteEnteghal(props)"
          >
            لغو درخواست
          </button>
        </div>
      </template>

      <template slot="tarixSanad" slot-scope="props">
        {{ props.row.zamanInsert }} {{ props.row.tarixSanad }}
      </template>
      <template slot="cardNo" slot-scope="props">
        {{ props.row.cardNo }}
        <!-- {{ props.row.cardNo ==null?"IR "+props.row.shebaNo:props.row.cardNo }} -->
      </template>
    </vue-bootstrap4-table>
      </template>
    </net-pa-card>
  </div>
</template>
<script>
import Panel from "../Tools/NetPa/Panel.vue";
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import VueBootstrap4Table from "vue-bootstrap4-table";
import loading from "../Tools/NetPa/Loading.vue";
export default {
  data() {
    return {
      DataAxios_DeleteEnteghal: {
        ArryfildValue: "",
        Method: "Post",
        Action: "Gardesh_Taahodat/RemoveBardasht",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_cmbTaahodat: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxiosRow: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListEnteghal",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_SahebHesab: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat/TaahodatSahebHesab",
        Token: this.$session.get("TokenNetPa"),
      },
      Resultcmb: null,
      IsLoad: false,
      ListModel: null,
      vCode: null,
      TarikhAz: "",
      TarikhTa: "",
      rows: [],
      columns: [
        {
          label: "id",
          name: "id",
          visibility: false,
        },
        {
          label: "ردیف",
          name: "row",
        },
        {
          label: "شماره حساب",
          name: "fromVcode",
        },
        {
          label: "نام صاحب حساب",
          name: "fromSahebHesab",
        },
        {
          label: "مبلغ انتقال",
          name: "mabEnteghal",
        },
        {
          label: "تاریخ درخواست",
          name: "tarixSanad",
          sort: true,
        },
        {
          label: "شماره شبا ",
          name: "shebaNo",
        },
        {
          label: "شماره کارت ",
          name: "cardNo",
          visibility: this.$session.get("CustCode") == 866 ? false : true,
        },
        {
          label: "کدرهگیری",
          name: "codeRahgiri",
        },
        {
          label: "وضعیت",
          name: "shomareSanad",
        },
        {
          label: "IsDeleted",
          name: "isDeleted",
          visibility: false,
        },
        {
          label: "توضیحات",
          name: "rejectMessage",
          visibility: true,
        },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: "",
        card_mode: false,
        global_search: {
          placeholder: " جستجو",
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: "table-bordered table-striped table-sm ",
      },
      loadingRender: false,
      ListModelSahebHesab: null,
    };
  },
  components: {
    Panel,
    NetPaCard,
    VueBootstrap4Table,
    loading,
  },
  mounted() {
    const formData = new FormData();
    let info;
    formData.append(
      "wwwtblAzaId",
      this.$session.get("UserInfoNetPa").wwwtblAzaId,
    );
    formData.append("wwwtblSarfaslTypeId", 2);
    this.DataAxios_cmbTaahodat.ArryfildValue = formData;
    this.$PostFormData(this.DataAxios_cmbTaahodat)
      .then((data) => {
        this.IsLoad = true;
        this.ListModel = data;
        this.Resultcmb = data[0].vCode;
      })
      .finally(() => {
        const formData = new FormData();
        formData.append(
          "wwwtblAzaId",
          this.$session.get("UserInfoNetPa").wwwtblAzaId,
        );
        formData.append("wwwtblSarfaslTypeId", 2);
        this.DataAxios_SahebHesab.ArryfildValue = formData;
        this.$PostFormData(this.DataAxios_SahebHesab).then((data) => {
          if (data.length > 0) {
            this.IsLoad = true;
            this.ListModelSahebHesab = data;
            for (
              let index = 0;
              index < this.ListModelSahebHesab.length;
              index++
            ) {
              if (this.ListModelSahebHesab[index].mande > 0) {
                info = this.ListModelSahebHesab[index];
                this.ListModel.push(info);
              }
            }
          }
        });
      });
  },
  methods: {
    normalizeStatusText(value) {
      if (value == null) return "";
      return String(value)
        .replace(/ي/g, "ی")
        .replace(/ك/g, "ک")
        .replace(/\s+/g, " ")
        .trim();
    },
    isFlagTrue(value) {
      return value === true || value === 1 || value === "1" || value === "true";
    },
    getRowStatus(row) {
      const raw = this.normalizeStatusText(row && row.shomareSanad);
      const isDeleted = this.isFlagTrue(row && row.isDeleted);
      const inProgress = this.isFlagTrue(row && row.inProgress);
      const rejectMessage = this.normalizeStatusText(
        row && row.rejectMessage,
      );
      const numericSanad = Number(raw.replace(/,/g, ""));
      const hasDocumentNo = raw !== "" && !isNaN(numericSanad) && numericSanad > 0;

      if (hasDocumentNo) {
        return {
          key: "approved",
          label: "تایید شده",
          canCancel: false,
          title: numericSanad === 1 ? "تایید شده" : "شماره سند: " + raw,
        };
      }

      if (raw.indexOf("رد شده توسط مدیر") !== -1 || (isDeleted && rejectMessage)) {
        return {
          key: "rejectedManager",
          label: "رد شده توسط مدیر",
          canCancel: false,
          title: rejectMessage || "رد شده توسط مدیر",
        };
      }

      if (raw.indexOf("رد شده توسط کاربر") !== -1 || isDeleted) {
        return {
          key: "rejectedUser",
          label: "رد شده توسط کاربر",
          canCancel: false,
          title: "رد شده توسط کاربر",
        };
      }

      if (inProgress) {
        return {
          key: "inProgress",
          label: "در حال بررسی",
          canCancel: false,
          title: "درخواست در حال بررسی است",
        };
      }

      return {
        key: "pending",
        label: "تایید نشده",
        canCancel: true,
        title: "درخواست هنوز تایید نشده است",
      };
    },
    statusOf(row) {
      return (row && row.statusMeta) || this.getRowStatus(row);
    },
    statusIcon(key) {
      const map = {
        approved: "fas fa-check-circle",
        inProgress: "fas fa-hourglass-half",
        pending: "far fa-clock",
        rejectedManager: "fas fa-times-circle",
        rejectedUser: "fas fa-user-times",
      };
      return map[key] || "fas fa-info-circle";
    },
    Deleteall(data) {
      var flag = 0;
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (this.getRowStatus(element).canCancel) {
          flag = 1;
          this.loadingRender = true;
          const formData = new FormData();
          formData.append("wwwtblEnteghal", element.id);
          formData.append("VCode", element.fromVcode);
          formData.append("Mablagh", element.mabEnteghal.replace(/,/g, ""));
          formData.append("wwwtblGardeshId", element.wwwtblGardeshId);
          this.DataAxios_DeleteEnteghal.ArryfildValue = formData;

          this.$PostFormData(this.DataAxios_DeleteEnteghal).then(() => {
            this.$mySweetDefaultTost(
              "حذف موفق",
              " حذف همه درخواست برداشت‌ها از حساب مورد نظر با موفقیت انجام شد",
              "success",
              4000,
            );

            this.loadingRender = false;
            this.GetDebtorReport();
          });
        }
      }
      if (flag == 0) {
        this.$mySweetDefaultTost(
          "خطا",
          "هیچ ردیفی برای لغو وجود ندارد ",
          "warning",
          2000,
        );
        return;
      }
    },
    GetDebtorReport() {
      if (this.Resultcmb == null || this.Resultcmb == -1) {
        this.$mySweetDefaultTost(
          "خطا",
          "لطفا یک حساب انتخاب کنید",
          "warning",
          2000,
        );
        this.rows = [];
      } else {
        this.loadingRender = true;
        const formData = new FormData();
        formData.append(
          "wwwtblAzaId",
          this.$session.get("UserInfoNetPa").wwwtblAzaId,
        );
        formData.append("AzTarix", this.TarikhAz);
        formData.append("TaTarix", this.TarikhTa);
        formData.append("Vcode", this.Resultcmb);
        this.DataAxiosRow.ArryfildValue = formData;
        this.$PostFormData(this.DataAxiosRow).then((data) => {
          //console.log("😎 ~ this.$PostFormData ~ data:", data)
          if (data.length) {
            let info;
            let list = [];
            if (data.length > 10) {
              this.config.pagination = true;
            } else {
              this.config.pagination = false;
            }
            for (let index = 0; index < data.length; index++) {
              info = data[index];
              info["row"] = index + 1;
              info.statusMeta = this.getRowStatus(info);
              list.push(info);
            }
            this.rows = this.$FormatMablaghGrid(list);
            this.loadingRender = false;
          } else {
            this.$mySweetDefaultTost(
              "عدم وجود اطلاعات",
              "درخواست انتقال یافت نشد ، فیلتر جستجوی خود را تغییر دهید",
              "warning",
              2000,
            );
            this.config.pagination = false;
            this.rows = [];
            this.loadingRender = false;
          }
        });
      }
    },
    DeleteEnteghal(item) {
      this.$SweetQustion(
        "حذف درخواست برداشت",
        "آیا از حذف درخواست برداشت خود اطمینان دارید؟",
        "error",
        "تایید",
        "انصراف",
        item,
        this.Delete,
        this.CancelDelete,
      );

      // console.log(item);
    },
    DeleteAllEnteghal(item) {
      this.$SweetQustion(
        "حذف درخواست‌های برداشت",
        "آیا از حذف درخواست برداشت‌های تایید نشده خود اطمینان دارید؟",
        "error",
        "تایید",
        "انصراف",
        item,
        this.Deleteall,
        this.CancelDelete,
      );

      // console.log(item);
    },
    Delete(node) {
      this.loadingRender = true;
      const formData = new FormData();
      formData.append("wwwtblEnteghal", node.row.id);
      formData.append("VCode", node.row.fromVcode);
      formData.append("Mablagh", node.row.mabEnteghal.replace(/,/g, ""));
      formData.append("wwwtblGardeshId", node.row.wwwtblGardeshId);
      this.DataAxios_DeleteEnteghal.ArryfildValue = formData;

      this.$PostFormData(this.DataAxios_DeleteEnteghal).then(() => {
        this.$mySweetDefaultTost(
          "حذف موفق",
          " حذف درخواست برداشت از حساب مورد نظر با موفقیت انجام شد",
          "success",
          4000,
        );

        this.loadingRender = false;
        this.GetDebtorReport();
      });
    },
    CancelDelete() {},
  },
};
</script>
<style scoped>
#DebtorReport {
  --bnp-brand-navy: #29345f;
  --bnp-brand-indigo: #56508d;
  --bnp-brand-purple: #8d58a4;
  --bnp-brand-blue: #287db4;
  --bnp-border-default: #dbe5eb;
  --bnp-border-subtle: #e8eef2;
  --bnp-shadow-md: 0 8px 18px rgba(41, 52, 95, 0.16);
  --bnp-focus-ring: 0 0 0 4px rgba(5, 184, 200, 0.2);
  --bnp-motion-fast: 180ms;
  --bnp-ease-standard: cubic-bezier(0.165, 0.84, 0.44, 1);
  --sv-control-h: 40px;
}

.debtor-report-filters {
  width: 100%;
  margin: 0 0 1rem;
  padding: 0 0 1rem;
  border-bottom: 1px solid #e8eef2;
}

.debtor-report-hint {
  margin: 0 0 0.85rem;
  color: #6b7b8e;
  font-size: 13px;
  line-height: 1.7;
}

.debtor-report-hint strong {
  color: #29345f;
  font-weight: 800;
}

.debtor-report-filters__row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 0.75rem;
  width: 100%;
}

.debtor-report-field {
  display: flex;
  flex: 0 1 11.5rem;
  flex-direction: column;
  min-width: 10rem;
  text-align: right;
}

.debtor-report-field--account {
  flex: 0 1 16rem;
  max-width: 16rem;
}

.debtor-report-field--action {
  flex: 0 0 auto;
  min-width: 0;
}

.debtor-report-label {
  display: block;
  margin-bottom: 0.35rem;
  min-height: 1.25rem;
  color: #29345f;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px !important;
  font-weight: 700;
  line-height: 1.25rem;
}

.debtor-report-label--spacer {
  visibility: hidden;
  user-select: none;
}

.debtor-report-field .form-control {
  width: 100%;
  height: 40px;
  min-height: 40px;
  margin: 0;
  padding: 0.4rem 0.75rem;
  overflow: hidden;
  color: #13243a;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.debtor-report-field .form-control:focus {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
  outline: none;
}

.debtor-report-field--date >>> .vpd-main {
  display: block;
  width: 100%;
}

.debtor-report-field--date >>> .vpd-input-group {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 40px;
  overflow: hidden;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.debtor-report-field--date >>> .vpd-input-group:focus-within {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
}

.debtor-report-field--date >>> .vpd-input-group input,
.debtor-report-field--date >>> .vpd-input-group input.form-control {
  width: 100%;
  min-width: 0;
  height: 40px;
  min-height: 40px;
  margin: 0;
  padding: 0.4rem 0.75rem;
  border: none !important;
  border-radius: 0 !important;
  background: transparent;
  box-shadow: none !important;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
}

.debtor-report-field--date >>> .vpd-input-group .vpd-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2.4rem;
  margin: 0 !important;
  padding: 0 0.6rem !important;
  color: #287db4;
  border: none;
  background: #edf5fb;
}

.sv-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: var(--sv-control-h);
  padding: 6px 14px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.4;
  border-radius: 12px;
  cursor: pointer;
  transition:
    color var(--bnp-motion-fast) var(--bnp-ease-standard),
    background var(--bnp-motion-fast) var(--bnp-ease-standard),
    border-color var(--bnp-motion-fast) var(--bnp-ease-standard),
    box-shadow var(--bnp-motion-fast) var(--bnp-ease-standard),
    transform var(--bnp-motion-fast) var(--bnp-ease-standard);
}

.sv-btn:focus {
  outline: none;
}

.sv-btn:focus-visible {
  box-shadow: var(--bnp-focus-ring);
}

.sv-btn--primary {
  color: #fff;
  border: 0;
  background: linear-gradient(
    110deg,
    var(--bnp-brand-navy),
    var(--bnp-brand-indigo) 58%,
    var(--bnp-brand-purple)
  );
  box-shadow: var(--bnp-shadow-md);
}

.sv-btn--primary:hover {
  color: #fff;
  transform: translateY(-1px);
}

.sv-btn--ghost {
  color: var(--bnp-brand-navy);
  border: 1px solid var(--bnp-border-default);
  background: #fff;
}

.sv-btn--ghost:hover {
  color: var(--bnp-brand-purple);
  border-color: rgba(141, 88, 164, 0.28);
  background: rgba(141, 88, 164, 0.05);
}

.debtor-report-search-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 6.75rem;
  min-height: 40px;
  height: 40px;
  margin: 0;
  padding: 0 1rem;
  border-radius: 12px;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 700;
}

.debtor-report-cancel-all-btn {
  min-width: 6.75rem;
  min-height: 40px;
  height: 40px;
  margin: 0;
  color: #b44f46;
  border-color: #f0d4d1;
  background: #fcefed;
}

.debtor-report-cancel-all-btn:hover {
  color: #fff;
  border-color: #b44f46;
  background: #b44f46;
}

@media (max-width: 767px) {
  .debtor-report-field,
  .debtor-report-field--account,
  .debtor-report-field--action {
    flex: 1 1 100%;
    min-width: 0;
  }

  .debtor-report-search-btn,
  .debtor-report-cancel-all-btn {
    width: 100%;
  }
}

.debtor-report-status {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 0.4rem;
}

.debtor-report-status__badge {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.2rem 0.55rem;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  white-space: nowrap;
}

.debtor-report-status--approved {
  color: #1e7e34;
  background: rgba(40, 167, 69, 0.1);
}

.debtor-report-status--inProgress {
  color: #c47d00;
  background: rgba(217, 119, 6, 0.12);
}

.debtor-report-status--pending {
  color: #495057;
  background: #f0f2f5;
}

.debtor-report-status--rejectedManager,
.debtor-report-status--rejectedUser {
  color: #c72816;
  background: rgba(199, 40, 22, 0.08);
}

.debtor-report-cancel-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.15rem 0.55rem;
  border: 1px solid #c72816;
  border-radius: 6px;
  background: #fff;
  color: #c72816;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  cursor: pointer;
  white-space: nowrap;
}

.debtor-report-cancel-btn:hover,
.debtor-report-cancel-btn:focus {
  outline: none;
  background: #c72816;
  color: #fff;
}
</style>
